// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__sULoz","ScrollX":"Scroll_ScrollX__YzCiq","ScrollY":"Scroll_ScrollY__ib-K4"};